import EventBus from '@/app/eventBus';
import { API, ENDPOINTS } from '@/app/services/api-url';
import Notification from '@/app/modules/_shared/components/MNotification/MNotification.vue';

export default {
  name: 'activity-notifcations',
  components: {
    Notification,
  },
  data: () => ({
    count: 0,
    notifications: [],
  }),
  computed: {
    sortedNotifications() {
      return [...this.notifications].reverse().slice(0, 4);
    },
  },
  methods: {
    handleAction(id) {
      const notifcation = this.notifications.find(item => id === item.id);
      if (notifcation.action.link) {
        this.$router.push({
          name: notifcation.action.link,
        });
        this.removeNotification(id);
      }
    },
    removeNotification(id) {
      this.notifications = this.notifications.filter(n => n.id !== id);
    },
    markNotificationAsRead(id) {
      const accountUUID = this.$store.getters['account/getActiveAccount'].uuid;
      const [notification] = this.notifications.filter(n => n.id === id);
      const payload = {
        accountID: accountUUID,
        notificationID: notification.uuid,
        type: 'NOTIFICATION_ACCOUNT',
        status: 'INACTIVE',
      };
      API.post(`${ENDPOINTS.POST_NOTIFICATION}`, payload)
        .then((res) => {
          if (res.status === 201) {
            this.removeNotification(id);
          } else {
            throw new Error('Unable to mark notification as read');
          }
        })
        .catch(err => console.log(err));
    },
    addNotification(payload) {
      const notification = {
        id: this.count,
        isReadable: false,
        isAction: false,
        ...payload,
      };
      // eslint-disable-next-line max-len
      const hasNotification = this.notifications.find(item => (notification.id === item.id || (notification.uuid && notification.uuid === item.uuid)));
      // If we have a notification already dont add it
      if (hasNotification) return;

      this.notifications.push(notification);
      // eslint-disable-next-line no-plusplus
      this.count++;
      if (!notification.isReadable && !notification.isAction) {
        setTimeout(() => {
          this.removeNotification(notification.id);
        }, 4000);
      }
    },
  },
  mounted() {
    EventBus.$on('addNotification', (payload) => {
      this.addNotification(payload);
    });
  },
};
